import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/sesam-swirl.png'


const _withScopeId = n => (_pushScopeId("data-v-fd00fafc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "o-header" }
const _hoisted_2 = { class: "o-header-nav" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.dnv.com/",
  class: "logo logo-sm",
  target: "_self"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://cdn.onedesign.dnv.com/onedesigncdn/2.7.0/images/DNV_logo_RGB.svg",
    alt: "DNV Logo",
    class: "logo-image"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["id"]
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "o-header-right" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sesam-image",
  src: _imports_0
}, null, -1))
const _hoisted_10 = { class: "site-title o-header-product" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "o-header-mobile-btn-icon" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", {
        class: _normalizeClass(["o-header-links", {show: _ctx.showMenu}])
      }, [
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            "aria-label": "Close Menu",
            class: "o-header-dropdown-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMenu = false))
          }, _hoisted_5)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: link.name,
            class: _normalizeClass(["o-header-item", { 'active': index === 0 }]),
            id: link.id
          }, [
            _createElementVNode("a", {
              href: link.url,
              class: "o-header-link"
            }, _toDisplayString(link.name), 9, _hoisted_7)
          ], 10, _hoisted_6))
        }), 128))
      ], 2),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.applicationName), 1)
      ]),
      _createElementVNode("button", {
        type: "button",
        "aria-label": "Toggle navigation",
        class: "o-header-mobile-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMenu = true))
      }, _hoisted_12)
    ])
  ]))
}